// @flow strict

export const toolbarExtendedHeight = 128;
export const toolbarHeight = 64;
